import { render } from "./GenreView.vue?vue&type=template&id=56585343&scoped=true&ts=true"
import script from "./GenreView.vue?vue&type=script&lang=ts"
export * from "./GenreView.vue?vue&type=script&lang=ts"

import "./GenreView.vue?vue&type=style&index=0&id=56585343&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56585343"]])

export default __exports__